import { has } from 'lodash';
import React from 'react';

import { FormattedMessage } from '@skippay/core/i18n/intl';

import i18n from './i18n';

function FormattedValidation(props) {
	const { value, format } = props;

	let labelKey = `validationErrors.${value}`;

	if (value === 'format' && !!format) {
		labelKey = `validationErrors.${value}.${format}`;
	}

	return has(i18n, labelKey) ? <FormattedMessage {...i18n[labelKey]} /> : value;
}

FormattedValidation.propTypes = {};

export default FormattedValidation;
